export default {
  'pages.forgotPassword.title': 'Reset password',
  'pages.forgotPassword.brand': 'Liulian AI',
  'pages.forgotPassword.subtitle': 'Reset your password with an email verification code',
  'pages.forgotPassword.email.placeholder': 'Email',
  'pages.forgotPassword.email.required': 'Please enter email',
  'pages.forgotPassword.email.invalid': 'Invalid email address',
  'pages.forgotPassword.captcha.placeholder': 'Verification code',
  'pages.forgotPassword.captcha.required': 'Please enter verification code',
  'pages.forgotPassword.captcha.sent': 'Verification code sent to your email',
  'pages.forgotPassword.password.placeholder': 'New password',
  'pages.forgotPassword.password.required': 'Please enter new password',
  'pages.forgotPassword.password.length': 'Password must be 4-20 characters',
  'pages.forgotPassword.confirmPassword.placeholder': 'Confirm new password',
  'pages.forgotPassword.confirmPassword.required': 'Please confirm your new password',
  'pages.forgotPassword.confirmPassword.mismatch': 'Passwords do not match',
  'pages.forgotPassword.step1.submit': 'Send code',
  'pages.forgotPassword.step2.submit': 'Verify',
  'pages.forgotPassword.step3.submit': 'Update password',
  'pages.forgotPassword.step1.error': 'Operation failed. Please check your email and try again.',
  'pages.forgotPassword.step2.error': 'Invalid verification code. Please try again.',
  'pages.forgotPassword.step3.error': 'Failed to update password. Please try again.',
  'pages.forgotPassword.success': 'Password reset successfully. Please sign in.',
  'pages.forgotPassword.backHome': 'Back to home',
  'pages.forgotPassword.rememberPassword': 'Remember your password? {login}',
  'pages.forgotPassword.loginNow': 'Sign in now',
};
